module.exports = __webpack_public_path__ + "img/vps_icon2.e567fb2.png";